import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { z } from 'zod';

import { DashboardContent } from '@/components/dashboard/dashboard-content';
import { useUser } from '@/firebase';

const indexSearchSchema = z.object({
  inviteToken: z.string().optional(),
  lang: z.string().optional(),
});

export const Route = createFileRoute('/')({
  component: RootPage,
  validateSearch: (search) => indexSearchSchema.parse(search),
});

// Main Root Page Component
function RootPage() {
  const { user, isUserLoading } = useUser();
  const search = Route.useSearch();

  // Show loading state
  if (isUserLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  // Conditional rendering based on auth status
  if (user) {
    // Authenticated: Show Dashboard, passing the parsed invitation token if present
    return <DashboardContent inviteToken={search.inviteToken} />;
  } else {
    // Not authenticated: Redirect to /login and preserve inviteToken if available
    return <Navigate to="/login" search={{ inviteToken: search.inviteToken, lang: search.lang }} replace />;
  }
}
